import angular from 'angular';
import _ from 'lodash';

angular.module('application').factory('confirmDialog', ["$mdDialog", "$translate", "appLoader", function($mdDialog, $translate, appLoader) {
    confirmDialogController.$inject = ["$scope", "message", "options"];

    function confirmDialogController($scope, message, options) {
        if(!_.isObject(options)) {
            options = {};
        }

        $scope.message = message;
        $scope.yesLabel = options.yesLabel || $translate.instant('APPLICATION.CONFIRM_DIALOG.YES');
        $scope.noLabel =  options.noLabel || $translate.instant('APPLICATION.CONFIRM_DIALOG.NO');

        $scope.cancel = function() {
            $mdDialog.hide(false);
        };

        $scope.confirm = function() {
            $mdDialog.hide(true);
        };
    }

    var confirmDialog = {
        show: function(message, options) {
            appLoader.hide();

            var defaultOptions = {
                controller: confirmDialogController,
                multiple: true,
                template: require('./confirm-dialog.html'),
                locals: {
                    message: message,
                    options: options
                }
            };

            if (options) {
                _.defaults(options, defaultOptions);

                if(options.blocking) {
                    options.clickOutsideToClose = false;
                    options.escapeToClose = false;
                }
            } else {
                options = defaultOptions;
            }

            return $mdDialog.show(options);
        }
    };

    return confirmDialog;
}]);
